export const validation = {
  fileError: "File error",
  uploadError: "Failed to upload file. Please try again.",
  tooManyFilesError: "Please ensure you only upload {size} files",
  required: "{fieldName} is required.",
  invalid: "{fieldName} is not valid.",
  maxLength: "{fieldName} must be at most {length} characters.",
  acknowledge: "Please read and acknowledge this box to continue",
};
